import {
  type EntitySyncConfigurationConstructor,
  EntitySyncConfiguration,
} from '../EntitySyncConfiguration/entitySyncConfiguration'
import { type EntitySyncConfigurationEntityEnum } from '../enums/EntitySyncConfigurationEntityEnum'
import {
  IntegrationNames,
  type IntegrationNameEnum,
} from '../enums/IntegrationNameEnum'
import {
  IntegrationStatuses,
  type IntegrationStatusEnum,
} from '../enums/IntegrationStatusEnum'

export interface IntegrationConstructor {
  id: string
  name: IntegrationNameEnum
  status: IntegrationStatusEnum
  entitySyncConfigurations: EntitySyncConfigurationConstructor[]
}

export class Integration {
  readonly id: string
  readonly name: IntegrationNameEnum
  readonly status: IntegrationStatusEnum
  readonly entitySyncConfigurations: EntitySyncConfiguration[]

  constructor(data: IntegrationConstructor) {
    this.id = data.id
    this.name = data.name
    this.status = data.status
    this.entitySyncConfigurations = data.entitySyncConfigurations.map(
      (config) => new EntitySyncConfiguration(config)
    )
  }

  getEntitySyncConfiguration(
    entityName: EntitySyncConfigurationEntityEnum
  ): EntitySyncConfiguration | null {
    return (
      this.entitySyncConfigurations.find(
        (config) => config.entity === entityName
      ) ?? null
    )
  }

  get isCodatServicePlatform(): boolean {
    return (
      this.name === IntegrationNames.CODAT_QUICKBOOKS_ONLINE ||
      this.name === IntegrationNames.CODAT_QUICKBOOKS_ONLINE_SANDBOX ||
      this.name === IntegrationNames.CODAT_SAGE_INTACCT ||
      this.name === IntegrationNames.CODAT_NETSUITE ||
      this.name === IntegrationNames.CODAT_DYNAMICS_365_BUSINESS_CENTRAL
    )
  }

  get isMergeServicePlatform(): boolean {
    return (
      this.name === IntegrationNames.MERGE_QUICKBOOKS_ONLINE ||
      this.name === IntegrationNames.MERGE_NETSUITE
    )
  }

  get isIntegrationServicePlatform(): boolean {
    return (
      this.name === IntegrationNames.NETSUITE ||
      this.isCodatServicePlatform ||
      this.isMergeServicePlatform
    )
  }

  get isActive(): boolean {
    return (
      this.isIntegrationServicePlatform &&
      this.status === IntegrationStatuses.ACTIVE
    )
  }

  get hasActiveConnection(): boolean {
    return (
      this.status === IntegrationStatuses.ACTIVE ||
      this.status === IntegrationStatuses.INITIALIZING
    )
  }
}
